module.exports = __webpack_public_path__ + "static/media/tween.987ecc7e.svg";